var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcReply = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_chevron_right copy 4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ytrytryryr",
    x: 0,
    y: 0,
    width: 1170,
    height: 382,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-2.0%",
    width: "102.0%",
    height: "106.0%",
    filterUnits: "objectBoundingBox",
    id: "quyuoiuyr"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "yituioytuyt",
    x: 0,
    y: 0,
    width: 1170,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,6.75 L7.5,3.75 L2.25,9 L7.5,14.25 L7.5,11.175 C11.25,11.175 13.875,12.375 15.75,15 C15,11.25 12.75,7.5 7.5,6.75 L7.5,6.75 Z",
    id: "qeqeqeqhohoh2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "laughtogers",
    x: 0,
    y: 0,
    width: 37.5,
    height: 37.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsneewws",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icnabelieve",
    transform: "translate(-1235.000000, -214.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "oopoopoioriwqrtaas11",
    transform: "translate(250.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "howmanyweqwe",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ytrytryryr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "jiojjker"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#quyuoiuyr)",
    xlinkHref: "#ytrytryryr"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#DFE2E5",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#ytrytryryr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rowenkosss",
    mask: "url(#howmanyweqwe)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "korewivanushka",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yituioytuyt"
  })), /*#__PURE__*/React.createElement("use", {
    id: "jiojjker",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#yituioytuyt"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chaoticksss-10",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#korewivanushka)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(644.000000, 25.000000)",
    id: "chaoticksss-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron_right-copy-4",
    transform: "translate(339.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dapamagize",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qeqeqeqhohoh2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "jiojjker"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chaoticksss",
    mask: "url(#dapamagize)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.750000, -9.750000)",
    id: "youaawronger"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "elonpamagiiplz",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#laughtogers"
  })), /*#__PURE__*/React.createElement("use", {
    id: "notblacckan",
    fill: "#E44D5F",
    xlinkHref: "#laughtogers"
  })))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcReply, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-reply.476bcd71.svg";
export { ForwardRef as ReactComponent };